// eslint-disable-next-line import/prefer-default-export
export const getProductGroups = (state) => state.associations.productGroupsList;
export const getErrorMessage = (state) => state.associations.errorMessage;
export const getViewedProductGroup = (state) => state.associations.viewedProductGroup;
